import axios from 'axios';
import useSession from "./../stateHooks/useSession.js";

function usePayment() {
    const baseUrl = process.env.REACT_APP_API_HOST;
    const sessionHk = useSession();

    async function create(payment) {
        const data = {
            ...payment,
            UserId: sessionHk.getCurrentUser()
        }
        const endpoint = '/api/Payment/create';
        const api = axios.create({ baseURL: baseUrl + endpoint });
        let isCreated = null;
        await api.post('',
            data,
            {
                headers: {
                    //'Authorization': `Bearer ${token}`
                }
            })
            .then(response => {
                isCreated = true;
            })
            .catch(error => {
                isCreated = false;
            });
        return isCreated;
    }

    async function readAll() {
        const endpoint = '/api/Payment/read_all';
        const api = axios.create({ baseURL: baseUrl + endpoint });
        let paymentList = [];
        await api.post('',
            {},
            {
                headers: {
                    //'Authorization': `Bearer ${token}`
                }
            })
            .then(response => {
                paymentList = response.data;
            })
            .catch(error => {
                paymentList = [];
            });
        return paymentList;
    };

    async function readId(id) {
        const endpoint = '/api/Payment/read_id';
        const api = axios.create({ baseURL: baseUrl + endpoint });
        let payment = null;
        let data = { 'Term': id };
        await api.post('',
            data,
            {
                headers: {
                    //'Authorization': `Bearer ${token}`
                }
            })
            .then(response => {
                payment = response.data;
            })
            .catch(error => {
                payment = null;
            });
        return payment;
    }

    async function deletePayment(payment) {
        const endpoint = '/api/Payment/delete';
        const api = axios.create({ baseURL: baseUrl + endpoint });
        let status = false;
        await api.post('',
            payment,
            {
                headers: {
                    //'Authorization': `Bearer ${token}`
                }
            })
            .then(response => {
                status = true;
            })
            .catch(error => {
                status = false;
            });
        return status;
    }

    async function update(payment) {
        const endpoint = '/api/Payment/update';
        const api = axios.create({ baseURL: baseUrl + endpoint });
        let status = false;
        await api.post('',
            payment,
            {
                headers: {
                    //'Authorization': `Bearer ${token}`
                }
            })
            .then(response => {
                status = true;
            })
            .catch(error => {
                status = false;
            });
        return status;
    }
    return {
        create,
        readAll,
        deletePayment,
        readId,
        update
    }
}

export default usePayment;